/**
 * AttachmentIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const AttachmentIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M9 22.424a7 7 0 0 1-4.95-11.95l7.07-7.07a5 5 0 0 1 7.07 7.07l-7.07 7.07a3 3 0 0 1-4.24-4.24l7.07-7.07a1 1 0 1 1 1.42 1.41l-7.08 7.08a1 1 0 1 0 1.42 1.41l7.07-7.07a3 3 0 0 0-4.24-4.24l-7.07 7.07a5 5 0 0 0 7.07 7.07l7.12-7.07a1 1 0 1 1 1.41 1.41L14 20.374a7 7 0 0 1-5 2.05" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const AttachmentIcon = makeIcon('AttachmentIcon', AttachmentIconSvg)
